<template>
  <div class="remote-section">
    <div class="description">
      <div class="section-title">
        Control your camera wirelessly with your smartphone or tablet
      </div>
      <div class="section-paragraph">
        Camoodoo lets you operate your camera with ease, even when it's hard to
        reach. Currently only Sony Cameras are supported, but other brands will
        join soon.
      </div>
      <div class="section-paragraph features">
        <icon-box src="/images/remote_shutter.svg"
          >Triggering the camera</icon-box
        >
        <icon-box src="/images/remote_settings.svg"
          >Change camera settings*</icon-box
        >
        <icon-box src="/images/remote_video.svg">Video recordings*</icon-box>
        <icon-box src="/images/remote_touch.svg">Touch Focus*</icon-box>
      </div>
      <div class="section-footnote">
        * Range and availability depends on the connected camera.
      </div>
    </div>
    <q-img class="image" src="images/remote_title.jpg" contain />
  </div>
</template>

<script>
import IconBox from "@/components/IconBox.vue";

export default {
  components: {
    IconBox,
  },
};
</script>

<style scoped>
.remote-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
}
.description {
  padding: var(--section-padding);
}
.features {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: var(--content-margin);
}
</style>
